import React from 'react';

/**
 * The night-blue phone frame the web2app funnel holds up, empty, while the
 * email's pay-link is looked up (FunnelAuthPage), so nothing of the funnel
 * shows before the answer. It was the welcome screen's stage; the welcome
 * screen itself is retired (the welcome experiment ended 2026-10-23 on
 * no-welcome: every visitor opens straight on picking a friend, or on the
 * intro entry's explainer slides).
 */
export const FunnelWelcomeFrame = () => (
  <main className="fw-bg">
    <FunnelWelcomeStyles />
    <div className="fw-frame" data-testid="funnel-welcome-pending" />
  </main>
);

const FunnelWelcomeStyles = () => (
  <style>{`
    .fw-bg {
      min-height: 100vh;
      min-height: 100dvh;
      background:
        radial-gradient(1000px 700px at 80% 0%, rgba(124,92,255,0.1), transparent 60%),
        linear-gradient(180deg, #F5FAFF 0%, #E8F1FF 100%);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /* On a phone the frame is the whole screen; on desktop it's a ~400px
       phone mockup inside the window, like the funnel's other screens */
    .fw-frame {
      width: 100%;
      height: 100vh;
      height: 100dvh;
      min-height: 600px;
      background: #0A1432;
    }

    @media (min-aspect-ratio: 3/4) {
      .fw-frame {
        width: auto;
        height: min(calc(100dvh - 48px), 920px);
        min-height: min(calc(100dvh - 48px), 600px);
        aspect-ratio: 390 / 844;
        border-radius: 32px;
        box-shadow: 0 24px 60px rgba(11,26,51,0.18), 0 4px 14px rgba(11,26,51,0.08);
      }
    }
  `}</style>
);
